// extracted by mini-css-extract-plugin
export default {"app":"styles_app__LFcse","title":"styles_title__e4Gdh","wrapper":"styles_wrapper__CNm8h"};